<template>
  <div>
    <b-row style="margin: 3px; border-bottom: 1px solid lightgray;">
      <b-col sm="12" lg="6" style="border-right: 1px solid lightgray;">
        <b-tabs>
          <b-tab :active="d_searchType === 'username'" @click="d_searchType = 'username'">
            <template slot="title">
              {{ StoreLangTranslation.data['username'][StoreLang] }}
            </template>
            <template v-if="d_searchType === 'username'">
              <b-row style="margin-top: 10px;">
                <b-col sm="12" lg="12">
                  <b-input-group>
                    <b-form-input type="text" class="form-control" v-model="d_searchUser" :placeholder="StoreLangTranslation.data['search_user'][StoreLang]"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="secondary" @click="f_searchUser()">
                        <i class="fa fa-search"></i>
                      </b-button>
                      <b-button variant="danger" @click="f_clearSearchUser()">
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col sm="12" lg="12">
                  <template v-if="d_userSearched">
                    <b-row style="margin: 10px 0px;">
                      <b-col sm="2" lg="2">
                        <b-button @click="f_selectAllSearchedUsers()" variant="success">
                          <i class="fa fa-arrow-right"></i><i class="fa fa-arrow-right"></i>
                        </b-button>
                      </b-col>
                      <b-col sm="2" lg="2">
                        <b-button @click="f_removeAllSearchedUsers()" variant="danger">
                          <i class="fa fa-arrow-left"></i><i class="fa fa-arrow-left"></i>
                        </b-button>
                      </b-col>
                      <b-col sm="8" lg="8">
                      </b-col>
                    </b-row>
                    <b-row v-if="d_filteredUsers.length" style="height: 185px; overflow: auto;">
                      <b-col sm="12" lg="12">
                        <b-row v-for="(user, index) in d_filteredUsers" :key="index">
                          <b-col sm="12" lg="12">
                            <!-- <span v-if="!d_selectedUsers.some(assignedUser => assignedUser === user.username)" style="cursor: pointer;" @click="f_addUser(user.username)">
                              <i class="fa fa-arrow-right"></i>
                              {{ user.username }}
                            </span> -->
                            <span v-if="!d_selectedUsers.some(assignedUser => assignedUser === user.username)" style="cursor: pointer;" @click="f_addUser(user.username)">
                              <i class="fa fa-arrow-right"></i>
                              {{ user.username }}
                            </span>
                            <span v-else style="opacity: 0.4;">
                              <i class="fa fa-arrow-right"></i>
                              {{ user.username }}
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row v-else>
                      <b-col sm="12" lg="12">
                        <b-row style="margin: 3px;">
                          <b-col sm="12" lg="12">
                            <span style="color: red;">
                              {{ StoreLangTranslation.data['user_not_found'][StoreLang] }}
                            </span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </template>
                </b-col>
              </b-row>
            </template>
          </b-tab>
        </b-tabs>
      </b-col>
      <b-col sm="12" lg="6" >
        <strong style="display: block;">{{ StoreLangTranslation.data['selected_users'][StoreLang] }}</strong>
        <hr/>
        <div style="height: 276px; overflow: auto;">
        <b-row v-for="username in d_selectedUsers" :key="username" style="margin: 3px;">
          <b-col sm="12" lg="12">
            <span style="cursor: pointer; color: green;" @click="f_removeUser(username)">
              <i class="fa fa-arrow-left"></i>
              {{ username }}
            </span>
          </b-col>
        </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row style="margin: 10px 3px;">
      <b-col sm="12" lg="2">
      </b-col>
      <b-col sm="12" lg="8">
        <strong>{{ StoreLangTranslation.data['mail_subject'][StoreLang] }}</strong>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="2">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="10">
            <b-form-input v-model="d_mailSubject[lang.label]" :placeholder="StoreLangTranslation.data['mail_subject'][StoreLang]"></b-form-input>
          </b-col>
        </b-row>
        <strong style="margin-top: 10px;">{{ StoreLangTranslation.data['mail_text'][StoreLang] }}</strong>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="2">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="10">
            <html-editor :key="lang_index" :p_html_text="d_mailText[lang.label]" :p_htmlElementId="'website_html_edit_' + lang.label"></html-editor>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="4">
      </b-col>
    </b-row>
                            <!-- SİLİNECEK KONTROL İÇİN DURUYOR -->
                            <!-- SİLİNECEK KONTROL İÇİN DURUYOR -->
                            <b-row>
                              <b-col sm="12" lg="4">
                              </b-col>
                              <b-col sm="12" lg="4">
                                <b-button @click="f_saveHtml()" style="width: 100%;">
                                  {{ StoreLangTranslation.data['save'][StoreLang] }}
                                </b-button>
                              </b-col>
                              <b-col sm="12" lg="2">
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="12" lg="2">
                              </b-col>
                              <b-col cols="8">
                                <b-row v-for="(lang, lang_index) in StoreLangList.data">
                                  <b-col cols="12">
                                    <strong>{{ lang.label }}</strong>
                                    <div v-html="d_mailText[lang.label]">
                                    </div>
                                  </b-col>
                                </b-row>
                                
                              </b-col>
                              <b-col sm="12" lg="2">
                              </b-col>
                            </b-row>
                            <!-- SİLİNECEK KONTROL İÇİN DURUYOR -->
                            <!-- SİLİNECEK KONTROL İÇİN DURUYOR -->
    <b-row style="margin: 3px;">
      <b-col sm="12" lg="5">
      </b-col>
      <b-col sm="12" lg="2">
        <template v-if="!d_mailSendLoading">
          <b-button v-if="!d_mailSendLoading" @click="f_sendMail()" variant="primary" style="width: 100%;">
            {{ StoreLangTranslation.data['send'][StoreLang] }}
          </b-button>
        </template>
        <template v-else variant="primary">
          <b-button variant="primary" style="width: 100%; opacity: 0.4;" disabled>
            <b-spinner variant="light" style="width: 18px; height: 18px;" label="Searching"></b-spinner>
          </b-button>
        </template>
          
      </b-col>
      <b-col sm="12" lg="5">
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { mapGetters } from 'vuex';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as HtmlEditor
} from '@/wam/components/widgets/HtmlEditor';
export default {
  name: 'sending_mail',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    HtmlEditor,
  },
  props: {},
  data () {
    return {
      d_userSearchLoading: false,
      d_searchUser: '',
      d_filteredUsers: [],
      d_userSearched: false,
      d_searchType: 'username',
      d_selectedUsers: [],
      d_mailSubject: {'en': '', 'tr': ''},
      d_mailSendLoading: false,
      d_mailText: {'en': '', 'tr': ''},
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_shp_bund').then(resp_wdm_data => { this.d_userShopBundleWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    let auth_eligible = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
    }
    if (!this.d_user || !this.d_user.username || !auth_eligible) {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
    
  },
  methods: {
    f_saveHtml: function () {
      for (let lang of this.StoreLangList.data) {
        let div_el = document.getElementById("website_html_edit_" + lang.label);
        let content = div_el.innerHTML.trim();
        if (!content.startsWith("<div")) {
          content = `<div>${div_el.innerHTML}</div>`;
          div_el.innerHTML = content;
        }
        this.d_mailText[lang.label] = div_el.innerHTML;
      }
    },
    f_removeAllSearchedUsers: function () {
      for (let i in this.d_filteredUsers) {
        let removeIndex = this.d_selectedUsers.indexOf(this.d_filteredUsers[i].username);
        if (removeIndex !== -1) {
          this.d_selectedUsers.splice(removeIndex, 1);
        }
      }
    },
    f_selectAllSearchedUsers: function () {
      for (let i in this.d_filteredUsers) {
        if (this.d_selectedUsers.indexOf(this.d_filteredUsers[i].username) === -1) {
          this.d_selectedUsers.push(this.d_filteredUsers[i].username);
        }
      }
    },
    f_sendMail: function () {
      if (this.d_mailText && this.d_mailSubject && this.d_selectedUsers.length > 0) {
        this.f_saveHtml();
        let isNotNull = true;
        for (let lang of this.StoreLangList.data) {
          if (!this.d_mailSubject[lang.label] || !this.d_mailText[lang.label]) {
            isNotNull = false;
          }
        }
        if (isNotNull) {
          this.d_mailSendLoading = true;
          let query = '';
          let data = {
            'mail_text': this.d_mailText,
            'username_list': this.d_selectedUsers,
            'subject': this.d_mailSubject,
          };
          // console.log('data: ', data)
          ServiceFunctions.send_mail(query, data)
            .then(resp => {
              this.d_mailSendLoading = false;
              if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
                // console.log(resp.data);
                alert(this.StoreLangTranslation.data['mail_send'][this.StoreLang])
              } else {
                let txt = 'status_code = ' + resp.data.status_code + '\n';
                txt += 'status_message = ' + resp.data.status_message;
                alert(txt);
              }
            });

        } else {
          alert(this.StoreLangTranslation.data['fill_mail_cell'][this.StoreLang])
        }
      } else {
        alert(this.StoreLangTranslation.data['there_is_not_any_selected_user'][this.StoreLang])
      }
    },
    f_searchUser: function () {
      if (this.d_searchUser || true) {
        this.d_userSearchLoading = true;
        const file_type = 'username';
        const match_type = 'include';
        const search_text = this.d_searchUser;
        let query = 'field_type=' + file_type + '&match_type=' + match_type;
        let data = {
          'search_text': search_text
        };
        
        ServiceFunctions.user_search(query, data)
          .then(resp => {
            this.d_userSearched = true;
            this.d_filteredUsers = [];
            this.d_userSearchLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              // console.log(resp.data);
              this.d_filteredUsers = resp.data.list;
            }
          });
      } else {
        alert(this.StoreLangTranslation.data['username_cannot_be_empty'][this.StoreLang]);
      }
    },
    f_clearSearchUser: function () {
      this.d_userSearched = false;
      this.d_searchUser = '';
    },
    f_addUser: function (username) {
      if (this.d_selectedUsers.indexOf(username) === -1) {
        this.d_selectedUsers.push(username);
      }
    },
    f_removeUser: function (username) {
      let removeIndex = this.d_selectedUsers.indexOf(username);
      if (removeIndex !== -1) {
        this.d_selectedUsers.splice(removeIndex, 1);
      }
    },
  },
  watch: {}
};

</script>

<style type="text/css"> </style>

